import PropTypes from 'prop-types';
import React from 'react';
import apiConfig from '../../config/api/apiConfig';
import WithUrl from '../../utils/WithUrl';
import DynamicBanner from './DynamicBanner/DynamicBanner';
import InformationBox from './InformationBox/InformationBox';
import NoResultsStyles from './NoResults.style';

/**
 * NoResults component displayed when search or filtering returns no results
 * @param {Object} props - Component props
 * @returns {React.ReactElement} NoResults component
 */
const NoResults = ({ regionCode, title, description, term }) => {
  const bannerUrl = apiConfig.getEnvironmentSpecificUrl(WithUrl('CATEGORY_BANNER', regionCode), 'www');

  return (
    <div className="no-result">
      <div className="container">
        <InformationBox title={title} description={description} term={term} />
        <DynamicBanner url={bannerUrl} />
      </div>
      <style jsx>{NoResultsStyles}</style>
    </div>
  );
};

NoResults.defaultProps = {
  description: '',
  term: '',
};

NoResults.propTypes = {
  regionCode: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  term: PropTypes.string,
};

export default NoResults;
